export default __webpack_public_path__ + "static/ministarstvo-8b88749618b7a2b8e4d8aeaf14898a63.png";